"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rangeToTextRects = void 0;
exports.rangeToTextRects = function (range) {
    var textNodeIterator = document.createNodeIterator(range.commonAncestorContainer, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (textNodeIterator.nextNode()) {
        var isValidNode = !(nodes.length === 0 && textNodeIterator.referenceNode !== range.startContainer);
        if (isValidNode) {
            nodes.push(textNodeIterator.referenceNode);
        }
        if (textNodeIterator.referenceNode === range.endContainer)
            break;
    }
    return nodes.reduce(function (rects, n, index) {
        var myRange = document.createRange();
        myRange.selectNode(n);
        if (index === 0) {
            myRange.setStart(n, range.startOffset);
        }
        if (index === nodes.length - 1) {
            myRange.setEnd(n, range.endOffset);
        }
        return __spreadArrays(rects, Array.from(myRange.getClientRects()));
    }, []);
};
//# sourceMappingURL=rangeToTextRects.js.map